import { getCookie, createCookie } from '@shopee/cookie';

export const DEVICE_FINGERPRINT_COOKIE_NAME = 'DF';
const DEVICE_FINGERPRINT_MAX_VALUE = 1000000000;

export function getDeviceFingerprint(): number {
  // 1. If cookie value is a number, returns it
  const deviceFingerprintText = getCookie(DEVICE_FINGERPRINT_COOKIE_NAME) || '';
  let deviceFingerprint = parseInt(deviceFingerprintText, 10);
  if (!isNaN(deviceFingerprint)) return deviceFingerprint;
  // 2. Else, generates device fingerprint, sets cookie, returns it
  deviceFingerprint = Math.floor(Math.random() * DEVICE_FINGERPRINT_MAX_VALUE);
  createCookie(
    DEVICE_FINGERPRINT_COOKIE_NAME,
    deviceFingerprint.toString(),
    365 // days
  );
  return deviceFingerprint;
}
